import type { ReceiptDetailView } from '../receipts.api';

const CAUSE_LABELS = { bounce: 'Bounced', correction: 'Reversed' } as const;

function Step({ title, children }: { title: string; children: string }) {
  return (
    <li className="flex flex-col gap-0.5">
      <span className="font-medium text-fg">{title}</span>
      <span className="text-muted">{children}</span>
    </li>
  );
}

const atTime = (iso: string) => new Date(iso).toLocaleString();

/**
 * What happened to the receipt, in order: recorded, cleared by the bank, bounced or reversed. Read from the receipt itself, so it shows to
 * anyone who can see receipts; the audit History below is for holders of `audit.view`.
 */
export function ReceiptChain({ receipt }: { receipt: ReceiptDetailView }) {
  const { clearance, reversal } = receipt;
  return (
    <section className="mt-10" aria-label="Chain">
      <h2 className="mb-4 text-base font-semibold text-fg">Chain</h2>
      <ol className="m-0 flex list-none flex-col gap-4 p-0">
        <Step title="Recorded">{`${receipt.recordedBy.name}, ${atTime(receipt.createdAt)}`}</Step>
        {clearance && <Step title={`Cleared on ${clearance.clearedOn}`}>{`Entered by ${clearance.recordedBy.name}, ${atTime(clearance.createdAt)}`}</Step>}
        {reversal && <Step title={CAUSE_LABELS[reversal.cause]}>{`${reversal.reason} — ${reversal.recordedBy.name}, ${atTime(reversal.createdAt)}`}</Step>}
      </ol>
    </section>
  );
}
